import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import LookingTodoNext from "../../components/landing/LookingTodoNext/LookingTodoNext";
import MyPropertyDetails from "../../components/viewMyPropertyDetails/MyPropertyDetails/MyPropertyDetails";
import MyPropertyDocuments from "../../components/viewMyPropertyDetails/MyPropertyDocuments/MyPropertyDocuments";
import Reports from "../../components/viewMyPropertyDetails/Reports/Reports";
import { accordionDataArray } from "../../components/viewMyPropertyDetails/TempData/TempData";
import { RootState } from "../../redux/reducers/root";
import { getViewPropertyDetails } from "../../redux/actions/viewPropertyDetails/viewPropertyDetails";
import { getPropertyDocuments } from "../../redux/actions/propertyDocuments/propertyDocuments";
// import { getDocument } from "../../redux/actions/document/document";
import { getReports } from "../../redux/actions/reports/reports";
// import { getReport } from "../../redux/actions/report/report";
import "./ViewMyPropertyDetails.css";
import AmpLoadingSpinner from "../../components/common/AmpLoadingSpinner/AmpLoadingSpinner";
import MailingAddress from "../../components/viewMyPropertyDetails/MailingAddress/MailingAddress";
import ReactGA from "react-ga4";

export default function ViewMyPropertyDetails(): JSX.Element {
    const dispatch = useDispatch();
    const mailUpdateEnabled = process.env?.REACT_APP_MAILING_ADDRESS_ENABLED === "1";
    const ownerType = window.localStorage.getItem("o_type")
    const { t } = useTranslation(["property"]);
    const [childComponents, setChildComponents] = useState([
        { name: "myPropertyDetails", translation: "my-property-details" },
        { name: "myPropertyDocuments", translation: "my-property-documents" },
        (mailUpdateEnabled) && { name: "mailingAddress", translation: "my-mailing-address" },
        { name: "reports", translation: "reports" }
    ])
    const [childComponent, setChildComponent] = useState("myPropertyDetails");
    const viewPropertyDetails = useSelector((state: RootState) => state.vwPropertyDetailsReducer.viewPropertyDetails)
    const propertyDocuments = useSelector((state: RootState) => state.propertyDocsReducer.propertyDocuments)
    const document = useSelector((state: RootState) => state.docReducer.document)
    const reports = useSelector((state: RootState) => state.repsReducer.reports)
    const report = useSelector((state: RootState) => state.repReducer.report)
    const propertyDetails = viewPropertyDetails["propertyDetails"]
    const pendingGettingPropertyDetails = viewPropertyDetails && viewPropertyDetails["loading"]
    const [propsData, setPropsData] = useState({})
    const [group, setGroup] = useState("")
    const [schoolSupportAccess, setSchoolSupportAccess] = useState<boolean | null>(null)
    const [docsAllowSS, setDocsAllowSS] = useState<boolean | null>(null)
    const [rollNum, setRollNum] = useState("")
    const [emailAddress, setEmailAddress] = useState("")
    const [schoolLeaseFlag, setSchoolLeaseFlag] = useState("N");

    const currentHost = window.location.protocol + '//' + window.location.hostname;

    useEffect(() => {
        const doCheck = async () => {
            setSchoolSupportAccess(false)
            setDocsAllowSS(false)
            setSchoolLeaseFlag("N")
            const propertyCode = window.localStorage.getItem("propertyCode") || ""
            const currentProperty = window.localStorage.getItem("currentProperty") || ""
            if (propertyDetails) {
                let access = false
                const firstDigit = ["1", "2", "3"]
                const propertyCodes = ["102", "103", "104", "105", "106", "107", "108", "112", "113", "114", "115", "120", "125", "127", "130", "134", "140", "150", "151", "155", "307", "363", "364", "371", "372", "382", "385", "386"]
                if (firstDigit.includes(propertyCode.substring(0, 1))) {
                    if (!propertyCodes.includes(propertyCode)) {
                        setRollNum(currentProperty)
                        setEmailAddress(propertyDetails["email_address"])
                        access = true
                        let eligibilityCount = 0
                        const occupants = propertyDetails["occupants"]
                        const ownerIds: string[] = [];
                        if (occupants?.length) {
                            for (const i in occupants) {
                                const ownerId = occupants[i]["ipsOwnerId"];
                                if (ownerId && occupants[i]["occupancyCode"] === "O" && occupants[i]["ownerPlateFlag"] && !ownerIds.includes(ownerId)) {
                                    if (occupants[i]["legalEntityCategoryCode"] !== "I") {
                                        access = false
                                        break
                                    } else {
                                        ++eligibilityCount
                                        ownerIds.push(ownerId)
                                        if (eligibilityCount > 4) {
                                            access = false
                                            break
                                        }
                                    }
                                }
                            }
                        }
                        if (access && rollNum) {
                            const formData = new FormData()
                            formData.append('roll_num', rollNum?.substring(0, 15))
                            await fetch(process.env.REACT_APP_SS_API + "get-residents-amp" || '', {
                                method: 'POST',
                                body: formData,
                                referrerPolicy: 'origin',
                                headers: {
                                    'Access-Control-Allow-Origin': '*',
                                    'Origin': currentHost,
                                    'Referer': currentHost + "/"
                                },
                            })
                                .then((response) => {
                                    return response.json()
                                })
                                .then((response) => {
                                    let ssOwners = false
                                    const ownerIds: string[] = []
                                    if (!response["msg"]) {
                                        let eligibilityCount = 0
                                        for (const i in response) {
                                            const resident = JSON.parse(response[i])
                                            const ownerId = resident["ips_owner_id"]
                                            if (ownerId && resident["occupancy_cd"] === "O") {
                                                ssOwners = true
                                                if (!ownerIds.includes(ownerId)) {
                                                    ++eligibilityCount
                                                    ownerIds.push(ownerId)
                                                    if (eligibilityCount > 4) {
                                                        ssOwners = false
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    access = ssOwners
                                })
                        }
                        if (rollNum) {
                            setSchoolSupportAccess(access)
                        }

                    }
                }
                const subordinates = propertyDetails["subordinates"]
                if (access && subordinates?.length) {
                    for (const i in subordinates) {
                        if (subordinates[i]["schoolLeaseFlag"] === "Y") {
                            setSchoolLeaseFlag("Y")
                            break
                        }
                    }
                }
            }
            if (propertyDocuments && propertyDocuments["propertyDocuments"]) {
                if (propertyDocuments["propertyDocuments"]["data"]?.length) {
                    setDocsAllowSS(true)
                }
            }
        }
        doCheck()
    }, [propertyDetails, propertyDocuments, viewPropertyDetails, rollNum, currentHost])

    useEffect(() => {
        const isTen = localStorage.getItem("o_type") === "ten";
        const ssAccess = schoolSupportAccess && docsAllowSS && !isTen;
        const components = [...childComponents];
        const ssIndex = components.map((e) => { return e.name }).indexOf("schoolSupport")
        const reportsIndex = components.map((e) => { return e.name }).indexOf("reports")
        if (ssAccess) {
            if (ssIndex === -1) {
                components.splice(reportsIndex, 0, { name: "schoolSupport", translation: "school-support" })
            }
        } else {
            if (ssIndex !== -1) {
                components.splice(ssIndex, 1)
            }
        }
        if (components.length !== childComponents.length) {
            setChildComponents(components);
        }
    }, [schoolSupportAccess, docsAllowSS, childComponents, viewPropertyDetails])

    useEffect(() => {
        const isTen = localStorage.getItem("o_type") === "ten"
        const components = [...childComponents];
        const ssIndex = components.map((e) => { return e.name }).indexOf("myPropertyDocuments")
        const detailsIndex = components.map((e) => { return e.name }).indexOf("myPropertyDetails")
        if (isTen) {
            if (ssIndex !== -1) {
                components.splice(ssIndex, 1)
            }
        } else {
            if (ssIndex === -1) {
                components.splice(detailsIndex + 1, 0, { name: "myPropertyDocuments", translation: "my-property-documents" })
            }
        }
        if (components.length !== childComponents.length) {
            setChildComponents(components);
        }
    }, [childComponents, viewPropertyDetails])

    useEffect(() => {
        if (propertyDetails) {
            return
        } else {
            const currentProperty = window.localStorage.getItem("currentProperty");
            const userProfileId = window.localStorage.getItem("userProfileId");
            if (currentProperty && userProfileId && !pendingGettingPropertyDetails) {
                dispatch(getViewPropertyDetails(userProfileId, currentProperty))
            }
        }
    }, [dispatch, propertyDetails, pendingGettingPropertyDetails])

    useEffect(() => {
        switch (childComponent) {
            case "myPropertyDocuments":
                ReactGA.send({ hitType: "pageview", page: "amp/property/documents", title: "My Documents" })
                break;
            case "reports":
                ReactGA.send({ hitType: "pageview", page: "amp/property/reports", title: "My Reports" })
                break;
        }
    }, [childComponent])

    useEffect(() => {
        const docs = propertyDocuments["propertyDocuments"]
        if (!report.report) {
            if (!docs && !propertyDocuments["loading"]) {
                const currentProperty = window.localStorage.getItem("currentProperty");
                const propertyId = window.localStorage.getItem("propertyId");
                if (currentProperty && propertyId) {
                    dispatch(getPropertyDocuments(currentProperty, propertyId));
                }
            }
        }
    }, [dispatch, propertyDocuments, report?.report])

    useEffect(() => {
        const pendingGettingReports = reports && reports["loading"]
        const currentProperty = window.localStorage.getItem("currentProperty");
        const propertyCode = window.localStorage.getItem("propertyCode");
        if (reports && reports["reports"]) {
            if (pendingGettingReports) {
                setChildComponent("myPropertyDetails")
            } else {
                if (!reports) {
                    if (currentProperty && propertyCode) {
                        dispatch(getReports(currentProperty.substring(0, 15), propertyCode))
                    }
                }
            }
        } else {
            if (!pendingGettingReports && !reports["reports"]) {
                if (currentProperty && propertyCode) {
                    dispatch(getReports(currentProperty.substring(0, 15), propertyCode))
                }
            }
        }
    }, [dispatch, reports, document, childComponent])

    useEffect(() => {
        setPropsData({})
        const temp = structuredClone(accordionDataArray)
        const propertyDetails = structuredClone(viewPropertyDetails["propertyDetails"])
        if (propertyDetails) {
            temp.forEach((e) => {
                const dataByKey = structuredClone(e.id)
                if (dataByKey && propertyDetails[dataByKey]) {
                    const values = structuredClone(e.data)
                    if (e.id === "primary_structures" || e.id === "secondary_structures" || (e.id === "improvements" && propertyDetails["improvements"])) {
                        const structs = structuredClone(propertyDetails[e.id])
                        if (structs?.length) {
                            let structsArr: typeof structs[] = []
                            structs.forEach((s: { [x: string]: string | number | never[]; }) => {
                                let structVals = structuredClone(values)
                                structVals = (structVals as typeof structs).filter((e: { id: string | number; }) => {
                                    return s[e.id]?.toString()
                                })
                                structVals.forEach((sv) => {
                                    sv.value = s[sv.id]
                                })
                                structsArr = [...structsArr, structVals]
                                setPropsData(propsData => {
                                    return { ...propsData, [e.id]: structsArr }
                                })
                            })
                        } else {
                            setPropsData(propsData => {
                                return { ...propsData, [e.id]: {} }
                            })
                            return
                        }
                    } else {
                        if (propertyDetails[e.id]) {
                            let address = ""
                            values.forEach((val) => {
                                if (val.id === "property_address") {
                                    address = propertyDetails[e.id][val.id]
                                }
                                val.value = propertyDetails[e.id] ? propertyDetails[e.id][val.id] : "N/A"
                                if (val.id === "legal_desc") {
                                    const legalDesc = propertyDetails[e.id][val.id]
                                    if (legalDesc?.trim() === address?.trim()) {
                                        val.value = ""
                                    }
                                }
                            })
                            const filteredValues = (values as []).filter((e: { value: string | undefined; id: string; }) => e.value !== undefined && (e.id === "legal_desc" ? e.value !== "" : true))
                            setPropsData(propsData => {
                                return { ...propsData, [e.id]: filteredValues || {} }
                            })
                        }
                    }
                }
            })
            if (propertyDetails["group"]) {
                setGroup(propertyDetails["group"])
            }
        }
    }, [viewPropertyDetails])

    const handleChildComponentChange = (name: string) => {
        setChildComponent(name)
    };
    const callSchoolSupport = async () => {
        const body = {
            roll_num: (rollNum?.toString())?.substring(0, 15),
            email_address: emailAddress,
            school_lease_flag: schoolLeaseFlag
        }
        await fetch(process.env.REACT_APP_SS_API + "token" || '', {
            method: 'POST',
            body: JSON.stringify(body),
            referrerPolicy: 'origin',
            headers: {
                'Content-Type': 'application/json',
                'Origin': currentHost,
                'Referer': currentHost + "/"
            }
        })
            .then((response) => {
                return response.json()
            })
            .then((response) => {
                ReactGA.event({
                    category: "School Support",
                    action: "School Support Clicked",
                    label: `School Support Clicked`, // optional
                });
                window.open(process.env.REACT_APP_SS_UI + response.access_token, '_blank')?.focus();
            })
    }

    return (
        <div className="view-my-property-details">
            <div className="page-description">
                <h1>{t("view-my-property-details") as string}</h1>
                <div>{t("description") as string}</div>
                <p>{t("description-2") as string}</p>
            </div>
            <AmpLoadingSpinner loading={false}>
                <div>
                    <div className="property-nav-parent">
                        {childComponents.map((e: { name: string; translation: string; } | false, i: React.Key) => {
                            if (!e) {
                                return false
                            }
                            else if (e.name === "mailingAddress" && ownerType !== "own" && ownerType !== "ttl") {
                                return false
                            }
                            return <div
                                className={
                                    "property-nav " +
                                    (childComponent === e.name ? "active" : "")
                                }
                                onClick={() => {
                                    if (e.name === "schoolSupport") {
                                        callSchoolSupport()
                                    } else {
                                        handleChildComponentChange(e.name)
                                    }
                                }}
                                key={i}
                            >
                                <div
                                    className="amp-anchor property-nav-text"
                                >
                                    {t("property-nav." + e.translation) as string}
                                </div>
                            </div>
                        })}
                    </div>
                    {childComponent === "myPropertyDetails" && <MyPropertyDetails loading={pendingGettingPropertyDetails} propsData={propsData} group={group} />}
                    {childComponent === "myPropertyDocuments" && <MyPropertyDocuments />}
                    {(childComponent === "mailingAddress" && (ownerType === "own" || ownerType === "ttl")) && <MailingAddress />}
                    {childComponent === "reports" && <Reports />}
                </div>
            </AmpLoadingSpinner>
            <div className="bottom-bar-container">
                <LookingTodoNext boxes={["bmn", "rfr"]} />
            </div>
        </div>
    );
}


